import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { TippyTooltip, Clickable, StreamlineIcon } from '@unowmooc/react-ui-kit'

import Cell from '../Cell'
import Menu from './Menu'

import styles from './styles.module.scss'

class CellAction extends Component {
  constructor(props) {
    super(props)

    this.openMenu = this.openMenu.bind(this)
    this.closeMenu = this.closeMenu.bind(this)

    this.state = { isMenuOpen: false }
  }

  get children() {
    const { data, children } = this.props

    return React.Children.map(children, child => {
      const { shouldBeDisplayed, ...rest } = child.props

      if (shouldBeDisplayed && !shouldBeDisplayed(data)) {
        return null
      }

      return React.cloneElement(child, { ...rest, data })
    })
  }

  openMenu() {
    document.addEventListener('click', this.closeMenu, false)
    this.setState({ isMenuOpen: true })
  }

  closeMenu() {
    document.removeEventListener('click', this.closeMenu, false)
    this.setState({ isMenuOpen: false })
  }

  render() {
    const { children } = this

    if (children.length === 0) {
      return null
    }

    const { data, ...rest } = this.props
    const { isMenuOpen } = this.state

    return (
      <Cell
        {...rest}
        align="right"
        verticalAlign="top"
        width={50}
        render={() => (
          <TippyTooltip
            inertia={false}
            trigger="manual"
            isVisible={isMenuOpen}
            interactive
            content={<Menu>{children}</Menu>}
            theme="cell-action-menu"
            placement="bottom-end"
            flipBehavior={['bottom-end', 'top-end', 'left']}
          >
            <div style={{ display: 'inline-block' }}>
              <Clickable onClick={this.openMenu} className={styles.button}>
                <StreamlineIcon icon="3dots" className={classnames(styles.icon, { [styles.active]: isMenuOpen })} />
              </Clickable>
            </div>
          </TippyTooltip>
        )}
      />
    )
  }
}

CellAction.type = 'action'

CellAction.defaultProps = {
  data: undefined,
}

CellAction.propTypes = {
  data: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
}

export default CellAction
